var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticStyle:{"overflow":"auto"},attrs:{"height":"40vh"}},_vm._l((_vm.biddingLog),function(bidding,index){return _c('Bidding',{key:index,attrs:{"bidding":bidding}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }